import React, { useState } from "react";

function PasswordReset() {
    console.log("does anything log?");
    const [responseMessage, setResponseMessage] = useState('');
    const [formData, setFormData] = useState({ email: '' });

    const handleInputChange = (e) => {
      setFormData({ email: e.target.value });
    };

    const handleSubmit = async (event) => {
      event.preventDefault();
      try {
        const response = await fetch(process.env.REACT_APP_PASSWORD_RESET_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        });
        const data = await response.json();
        if (response.ok) {
          setResponseMessage('Check your email for a reset link.');
        } else {
          setResponseMessage('Error: ' + data.message);
        }
      } catch (error) {
        setResponseMessage('Network error occurred.');
      }
    };

      return (
    <div >
      

      <div className="page-header align-items-start min-vh-50 m-3 border-radius-lg" style= {{ backgroundImage: `url('https://images.unsplash.com/photo-1497996541515-6549b145cd90?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1650&q=80')` }} loading="lazy">
    <span className="mask bg-gradient-dark opacity-6"></span>
  </div>
  <div className="container mb-4">
    <div className="row mt-lg-n12 mt-md-n12 mt-n12 justify-content-center">
      <div className="col-xl-4 col-lg-5 col-md-7 mx-auto">
        <div className="card mt-8">
          <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div className="bg-gradient-warning shadow-warning border-radius-lg py-3 pe-1 text-center py-4">
              <h3 className="font-weight-bolder text-white">Reset Password</h3>
              <p className="mb-0 text-sm text-white">You will receive an e-mail in maximum 60 seconds</p>
            </div>
          </div>
          <div className="card-body py-4">
            <form onSubmit={handleSubmit}>
              <div className="input-group input-group-static mb-4">
                <label>Email</label>
                <input type="email" className="form-control" placeholder="john@email.com" name="email" value={formData.email} onChange={handleInputChange} />
              </div>
              {responseMessage && <p className="text-sm text-center mt-2">{responseMessage}</p>}
              <div className="text-center">
                <button type="submit" className="btn bg-gradient-warning w-100 mt-4 mb-0">Reset</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  

    </div>
      );
    }
    
    export default PasswordReset;